import { render, staticRenderFns } from "./general-inventory-report.vue?vue&type=template&id=88b4f480&"
import script from "./general-inventory-report.vue?vue&type=script&lang=ts&"
export * from "./general-inventory-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports